import { createSelector } from '@ngrx/store';

import { previewSelector } from './preview.selectors';
import * as fromPreviewOrders from '../reducers/preview-orders.reducer';

export const selectPreviewOrdersState = createSelector(previewSelector, (state) => state[fromPreviewOrders.featureKey]);

export const selectOrders = createSelector(selectPreviewOrdersState, fromPreviewOrders.getOrders);

export const selectTotalCountOrders = createSelector(selectPreviewOrdersState, fromPreviewOrders.getCountOrders);

export const selectOrdersLoading = createSelector(selectPreviewOrdersState, fromPreviewOrders.getLoading);
